<template>
  <b-container class="pb-0">
    <b-row>
      <b-col cols="6" class="pb-0">
        <b-form-group label="Recurring Amount" label-for="amount" class="mb-0">
          <div class="input-group" style="flex-direction:row">
            <b-row class="input-group-prepend px-0" id="currency_parent">
              <b-col
                cols="12"
                :sm="size.currency_sm"
                class="pr-0"
                id="currency_select"
              >
                <v-autocomplete
                  v-on:change="currencyAutoMove"
                  id="currency"
                  v-model="localValue.currency"
                  name="currency"
                  :items="currencies"
                  :filter="autoCompleteStringFilter"
                  item-text="text"
                  item-value="value"
                  autocomplete="currency"
                  outlined
                  dense
                ></v-autocomplete>
              </b-col>
              <b-col
                cols="12"
                :sm="size.currencyAmount_sm"
                class="pl-0"
                id="currency_input"
              >
                <b-form-input
                  ref="currencyAmount"
                  id="amount"
                  v-model="localValue.amount"
                  type="text"
                  :state="state('amount')"
                  aria-describedby="amount-error"
                />
              </b-col>
            </b-row>
          </div> </b-form-group
      ></b-col>
      <b-col cols="6" class="pb-0" id="initial-payment">
        <b-col>
          <b-form-group
            label="Initial Payment"
            label-for="initialPaymentAmount"
          >
            <b-form-input
              id="initialPaymentAmount"
              v-model="localValue.initialPaymentAmount"
              type="text"
              :state="state('amount')"
              aria-describedby="initial-amount-error"
            />
            <b-form-invalid-feedback id="initial-amount-error">
              {{ errors.initialPaymentAmount }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AutoNumeric from "autonumeric";
import { autoCompleteStringFilter } from "@/services/Formatting.js";
import CurrencyMixin from "@/components/payment/CurrencyMixin.js";

export default {
  mixins: [CurrencyMixin],
  props: {
    size: {
      type: Object,
      default() {
        return {
          currency_sm: 5,
          currencyAmount_sm: 7
        };
      }
    },
    currencies: {
      type: Array
    },
    value: {
      amount: {
        type: Number,
        default: 0
      },
      currency: {
        type: String
      },
      initialPaymentAmount: {
        type: Number,
        default: 0
      }
    },
    autoNumericOptions: null,
    errorMessages: {
      type: Object,
      required: false,
      default() {
        return {
          amount: null,
          currency: null
        };
      }
    }
  },
  data() {
    return {
      amountAutoNumericElement: {},
      initialAmountAutoNumericElement: {}
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set() {}
    },
    errors() {
      return {
        amount: this.getErrorMessage("amount"),
        currency: this.getErrorMessage("currency"),
        initialPaymentAmount: this.getErrorMessage("initialPaymentAmount")
      };
    },
    AutoNumericOptions() {
      if (this.autoNumericOptions != null) return this.autoNumericOptions;
      return {};
    }
  },
  methods: {
    autoCompleteStringFilter(item, searchText, itemText) {
      return autoCompleteStringFilter(item, searchText, itemText);
    },
    currencyAutoMove() {
      this.$refs.currencyAmount.focus();
    },
    getErrorMessage(name) {
      return !!this.errorMessages ? this.errorMessages[name] : null;
    },
    state(name) {
      return this.errors[name] == null ? null : !this.errors[name].length;
    },
    setupAutoNumericElement(fieldId) {
      let autoNumericElement = AutoNumeric.getAutoNumericElement(
        document.getElementById(fieldId)
      );
      if (autoNumericElement === null) {
        autoNumericElement = new AutoNumeric(`#${fieldId}`, {
          ...this.AutoNumericOptions,
          ...{
            digitGroupSeparator: ",",
            decimalCharacter: "."
          }
        });
      }

      autoNumericElement.set(this.value.amount);
      return autoNumericElement;
    }
  },
  async mounted() {
    this.localValue.currency = this.localValue.currency
      ? this.localValue.currency
      : this.defaultCurrencyCode;
    this.amountAutoNumericElement = this.setupAutoNumericElement("amount");
    this.initialAmountAutoNumericElement = this.setupAutoNumericElement(
      "initialPaymentAmount"
    );
  }
};
</script>

<style lang="scss" scoped>
#initial-payment {
  padding: 0;
}

#currency_parent {
  margin: 0;
}
label {
  font-weight: 500;
}
</style>
